import * as Yup from "yup";

export default Yup.object().shape({
    id: Yup.number(),
    name: Yup.string().required("Name is required"),
    description: Yup.string().nullable(),
});